import { render, staticRenderFns } from "./form-bank-offer.vue?vue&type=template&id=fc189352&"
import script from "./form-bank-offer.vue?vue&type=script&lang=js&"
export * from "./form-bank-offer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InputsInput: require('/var/www/components/inputs/input.vue').default,CheckboxGroup: require('/var/www/components/checkbox/checkbox-group.vue').default,PictureComponent: require('/var/www/components/picture/picture-component.vue').default})
